import { combineReducers } from "redux";

import {
    SET_USER_DATA,
    SET_USER_PROFILE
} from '../constants/actionTypes';

const initState = {
    user: null,
    profile: null
}

export function userData(state = initState.user, action) {
    switch(action.type) {
        case SET_USER_DATA:
            return action.user
        default:
            return state;
    }
}

export function profileData(state = initState.profile, action) {
    switch(action.type) {
        case SET_USER_PROFILE:
            return action.profile
        default:
            return state;
    }
}


export default combineReducers({
    user: userData,
    profile: profileData
})